import { ExternalAspect } from "./type";

export function newExternalAspect(): ExternalAspect {
    return {
        id: undefined,
        roof_covering_id: null,
        main_wall_id: null,
        window_type_id: null,
        external_facade_id: null,
        garden_id: null,
        has_other: false,
        other_aspects: null,

        chimney_stack_id: null,
        chimney_stack_comment: null,
        roof_covering_comment: null,
        rainwater_pipe_id: null,
        rainwater_pipe_comment: null,
        main_wall_comment: null,
        window_type_comment: null,
        outside_door_id: null,
        outside_door_comment: null,
        conservatory_id: null,
        conservatory_comment: null,
        other_joinery_id: null,
        other_joinery_comment: null,
        loading_dock: false,
        loading_dock_num: null,
        loading_dock_comment: null,
        external_facade_comment: null,
    }
}